module.exports = __webpack_public_path__ + "img/IMG-20200119-WA0002.1190ec57.jpg";